import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal-confirmacao-ponto',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-confirmacao-ponto.component.html',
  styleUrls: ['./modal-confirmacao-ponto.component.css']
})
export class ModalConfirmacaoPontoComponent {
  @Input() visivel = false;
  @Input() titulo = 'Ponto registrado com sucesso.';
  @Input() nome = '';
  @Input() horario = '';
}
